import ActivityParticipantSummary from "apps/console/modules/program/workflow/associateProgram/components/activityParticipantSummary";
import Icon from "assets/icons";
import sortBy from "lodash/sortBy";
import xor from "lodash/xor";
import { Outlet, useNavigate } from "react-router-dom";
import ActionCountBar from "shared/components/actionCountBar";
import Button from "shared/components/button";
import NoDataFound from "shared/components/noDataFound";
import TopNoteWithApi from "shared/components/topNote/topNoteWithApi";
import ContextEntityType from "shared/enums/ContextEntityType";
import ProgramAgendaStatus from "shared/enums/ProgramAgendaStatus";
import UtilityDataModule from "shared/enums/UtilityDataModule";
import Variant from "shared/enums/Variant";
import CheckBox from "shared/form/core/checkbox";
import Radio from "shared/form/core/radio";
import { useCopies } from "shared/hooks/useCopies";
import DateTimeHelper from "shared/utils/dateTimeHelper";
import ManageActivityCard from "../../invitesSent/list/components/manageActivityCard";
import { useActivityAgendaListingService } from "./service";
import { useMyExpAnalytics } from "apps/myExperience/context/analyticsWrapper";

export default function ActivityAgendaScheduleListing() {
  const copies = useCopies();
  const { logEvent } = useMyExpAnalytics();
  const service = useActivityAgendaListingService();
  const navigate = useNavigate();
  return (
    <div className="activityAgendaSchedule filtersAndListing">
      <TopNoteWithApi
        registrationId={service.registrationId ?? ""}
        contextEntityType={ContextEntityType.PROGRAM}
        contextEntityId={service.programId ?? ""}
        module={UtilityDataModule.ACTIVITY_ADMIN_ACCEPT_REJECT}
        logEvent={logEvent}
      />
      <div className="filtersAndListing-body">
        <div className="filtersAndListing-filters">
          <div className="filtersAndListing-filters_title">
            <div className="block"></div>
          </div>
          <div className="filtersAndListing-filters_wrapper">
            <span className="filtersAndListing-filters_inner_title">
              <span className="label">Status</span>
              <Button
                variant={Variant.LINK}
                label={copies.get("clear.all")}
                onClick={() => service.setFilters([])}
                disabled={service.filters.length === 0}
              />
            </span>
            <div className="filtersAndListing-filters_inner_body">
              {service.filterOptions.map(item => {
                return (
                  <div className="filtersAndListing-filters_inner_body_item">
                    <CheckBox
                      name=""
                      label={item.customData.filterlabel}
                      checked={service.filters.includes(item.value as ProgramAgendaStatus)}
                      onChange={() => {
                        service.setFilters(xor(service.filters, [item.value as ProgramAgendaStatus]));
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="filtersAndListing-listing">
          <div className="filtersAndListing-listing_inner_topAction">
            {!!service.data?.length && (
              <div className="acceptMeetings_header_right_info">
                <ActionCountBar
                  totalCount={service.agendas?.length || 0}
                  pendingCount={service.actionable?.pending}
                  completedCount={service.actionable?.completed}
                />
              </div>
            )}
          </div>
          <div className="filtersAndListing-listing_inner">
            {!Boolean(service.data?.length) && <NoDataFound height="50vh" />}
            {sortBy(service.data, "time.timeFrom")?.map(item => (
              <ManageActivityCard
                name={item.name}
                activityDate={DateTimeHelper.formatDate({
                  startDate: item.time.timeFrom,
                  endDate: item.time.timeTo,
                  timeZone: item.time.timeZoneDisplayStr,
                  option: {
                    showTime: true,
                    showWeekDay: true,
                    showYear: false
                  }
                })}
                activityLocation={item.location}
                activitySponsored={item.label}
                action={
                  <div className="manageActivityCardActions">
                    <div className="manageActivityCardActions_topRow">
                      <div className="activityAcceptRejectActions">
                        {service.behavior.nextScheduleActionList(copies, item.status)?.map((action, index) => {
                          return (
                            <Radio
                              value=""
                              name=""
                              label={action.label}
                              checked={action.value === item.status}
                              onChange={async () => {
                                try {
                                  await service.handleUpdateAgenda({
                                    id: item.id,
                                    status: action.value as ProgramAgendaStatus,
                                    uiVersion: item.uiVersion,
                                    hasConfirmation: action.customData?.hasConfirmation
                                  });
                                  service.handleRefreshProgramActions();
                                } catch (error) {}
                              }}
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="manageActivityCardActions_bottomRow">
                      <ActivityParticipantSummary activitySummary={item.summary} horizontalStyle />
                      <Button
                        icon={<Icon.Settings size={16} />}
                        label={copies.get("manage.participants.label.in.list")}
                        variant={Variant.LINK}
                        onClick={() => navigate(item.id)}
                      />
                    </div>
                  </div>
                }
              />
            ))}
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
